import { FC, useState } from "react";
import { Button } from "../../../../components";
import { PlusIcon } from "../../../../assets/icons";
import { useLoanApplication } from "../../../../contexts";
import { getVendorNature, getVendorTitle } from "../../VendorInformation/utils";
import { LoanProductType, Vendor } from "../../../../hooks/api/types";
import { useDeleteVendor, useGetApplicationVendors } from "../../../../hooks";
import VendorCard from "../../VendorInformation/VendorCard";
import VendorInformationModal from "../../VendorInformation/VendorInformationModal";

type Props = {};

const VendorReviewSection: FC<Props> = ({}) => {
  const {
    state: { loanType, id },
  } = useLoanApplication();
  const { data: vendors, refetch } = useGetApplicationVendors({
    loanApplicationId: id,
    disablePagination: true,
  });
  const { mutateAsync: deleteVendor } = useDeleteVendor();

  const [focusedVendor, setFocusedVendor] = useState<Vendor | undefined>(
    undefined
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="cx-bg-white cx-rounded-lg cx-w-full cx-max-w-full cx-shadow-md cx-p-4 sm:cx-p-5 md:cx-p-10 cx-mt-10 cx-overflow-hidden">
      <div className="cx-flex cx-flex-row cx-items-center cx-justify-between cx-gap-2 cx-w-full cx-min-w-0 cx-mb-6">
        <div className="cx-min-w-0 cx-flex-1 cx-text-base md:cx-text-xl cx-font-bold cx-leading-snug">
          {getVendorTitle(loanType as LoanProductType)}
          <br />
          Information
        </div>
        <Button
          label={
            <div className="cx-flex cx-items-center cx-gap-1 cx-whitespace-nowrap cx-text-xs md:cx-text-sm">
              <PlusIcon className="cx-w-4 cx-h-4 cx-shrink-0" />
              <span>{`Add ${getVendorNature(
                loanType as LoanProductType
              )}`}</span>
            </div>
          }
          slim={true}
          className="cx-shrink-0"
          onClick={() => {
            setFocusedVendor(undefined);
            setIsModalOpen(true);
          }}
        />
      </div>
      <div className="cx-flex cx-flex-row cx-flex-wrap cx-gap-4 cx-justify-start">
        {vendors?.data.map((vendor) => {
          return (
            <VendorCard
              loanType={loanType}
              loanApplicationId={id}
              vendor={vendor}
              onDelete={async () => {
                await deleteVendor({
                  loanApplicationId: id,
                  loanVendorId: vendor.loanVendorId,
                });
                await refetch();
              }}
              onEdit={() => {
                setFocusedVendor(vendor);
                setIsModalOpen(true);
              }}
              onVendorUpdate={refetch}
              className="cx-w-full cx-max-w-[428px]"
            />
          );
        })}
      </div>
      <VendorInformationModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setFocusedVendor(undefined);
        }}
        onAddVendor={async () => {
          refetch();
        }}
        vendorState={focusedVendor}
      />
    </div>
  );
};

export default VendorReviewSection;
